import React, { useState } from 'react'
import { Button } from '../components/ui/Button'
import { Input, Select } from '../components/ui/Input'
import { StatusBadge } from '../components/ui/Badge'
import { LoadingCard } from '../components/ui/LoadingSpinner'
import { 
  Search, 
  Filter, 
  Shield, 
  User, 
  Calendar,
  Activity,
  Download
} from 'lucide-react'

export const AuditPage: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('')
  const [actionFilter, setActionFilter] = useState('')
  const [userFilter, setUserFilter] = useState('')
  const [dateFilter, setDateFilter] = useState('')

  const actionOptions = [
    { value: '', label: 'All Actions' },
    { value: 'create', label: 'Create' },
    { value: 'read', label: 'Read' },
    { value: 'update', label: 'Update' },
    { value: 'delete', label: 'Delete' },
  ]

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 tracking-tight">Audit Logs</h1>
          <p className="text-gray-600">Track system activity and user actions</p>
        </div>
        
        <Button variant="outline">
          <Download className="w-4 h-4 mr-2" />
          Export Logs
        </Button>
      </div>

      {/* Filters */}
      <div className="card">
        <div className="card-content">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            <Input
              placeholder="Search logs..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              leftIcon={<Search className="w-4 h-4" />}
            />
            
            <Select
              placeholder="Filter by action"
              value={actionFilter}
              onChange={(e) => setActionFilter(e.target.value)}
              options={actionOptions}
            />
            
            <Select
              placeholder="Filter by user"
              value={userFilter}
              onChange={(e) => setUserFilter(e.target.value)}
              options={[
                { value: '', label: 'All Users' },
                // This would be populated from users API
              ]}
            />
            
            <Input
              type="date"
              placeholder="Filter by date"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
            />
            
            <Button
              variant="outline"
              onClick={() => {
                setSearchQuery('')
                setActionFilter('')
                setUserFilter('')
                setDateFilter('')
              }}
            >
              <Filter className="w-4 h-4 mr-2" />
              Clear
            </Button>
          </div>
        </div>
      </div>

      {/* Audit Logs List */}
      <div className="space-y-4">
        <div className="text-center py-12">
          <Shield className="w-12 h-12 text-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Audit logs will be displayed here</h3>
          <p className="text-gray-500">
            System activity and user actions will be tracked and displayed in this section.
          </p>
        </div>
      </div>
    </div>
  )
}

export default AuditPage